export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_SUCCESS_DELETE = "SIGNUP_SUCCESS_DELETE";
export const SIGNUP_FAIL = "SIGNUP_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGIN_OUT";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const RESETPASSWORD_SUCCESS = "RESETPASSWORD_SUCCESS";
export const RESETPASSWORD_FAIL = "RESETPASSWORD_FAIL";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_ERROR_RESET = "AUTH_ERROR_RESET";
export const REGISTER_AUTH_USER = "REGISTER_AUTH_USER";
export const FETCH_ACCOUNT_SETTINGS = "FETCH_ACCOUNT_SETTINGS";
export const INIT_ACCOUNT_PROFILE = "INIT_ACCOUNT_PROFILE";
export const SHOP_ACCOUNT_PROFILE = "SHOP_ACCOUNT_PROFILE";
export const INIT_INVALID_TIME = "INIT_INVALID_TIME";
export const INITUSERLOGINCHANGE = "INITUSERLOGINCHANGE";
export const INIT_VALID_TIME = "INIT_VALID_TIME";
export const FETCH_REPAIR_DEVICES = "FETCH_REPAIR_DEVICES";
export const SET_LOADED_PROFILE = "SET_LOADED_PROFILE";
export const INIT_ACCOUNT_REVIEWS = "INIT_ACCOUNT_REVIEWS";
export const INIT_LOAD_VALID_TIME = "INIT_LOAD_VALID_TIME";
export const SET_GUARANTEE_DEVICE = "SET_GUARANTEE_DEVICE";
export const SET_BRAND_MODEL = "SET_BRAND_MODEL";
export const FETCH_SHOP_MODEL_GUARANTEE = "FETCH_SHOP_MODEL_GUARANTEE";
export const SET_LOAD_PBM = "SET_LOAD_PBM";
export const SET_SEELCT_SHOP_GUARANTEE = "SET_SEELCT_SHOP_GUARANTEE";
export const SET_CREATED_GUARANTEE = "SET_CREATED_GUARANTEE";
export const SET_DELETED_GUARANTEE = "SET_DELETED_GUARANTEE";
export const UPDATE_SCHEDULE_TIME = "UPDATE_SCHEDULE_TIME";
export const HANDLE_CHECK_TIME = "HANDLE_CHECK_TIME";
export const SET_SUCESS_DATA = "SET_SUCESS_DATA";
export const SET_REPARATION_DATA = "SET_REPARATION_DATA";
export const CHECK_AUTHENTICATION = "CHECK_AUTHENTICATION";

export default {
  SIGNUP_SUCCESS,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  AUTH_ERROR_RESET,
  REGISTER_AUTH_USER,
  FETCH_ACCOUNT_SETTINGS,
  RESETPASSWORD_FAIL,
  RESETPASSWORD_SUCCESS,
  INIT_ACCOUNT_PROFILE,
  INIT_INVALID_TIME,
  INIT_LOAD_VALID_TIME,
  INIT_VALID_TIME,
  FETCH_REPAIR_DEVICES,
  SET_LOADED_PROFILE,
  INIT_ACCOUNT_REVIEWS,
  SET_GUARANTEE_DEVICE,
  SET_BRAND_MODEL,
  SET_LOAD_PBM,
  SET_SEELCT_SHOP_GUARANTEE,
  SET_CREATED_GUARANTEE,
  SET_DELETED_GUARANTEE,
};
